import { render, staticRenderFns } from "./column-panel.vue?vue&type=template&id=04ae6f48"
import script from "./column-panel.vue?vue&type=script&lang=js"
export * from "./column-panel.vue?vue&type=script&lang=js"
import style0 from "./column-panel.vue?vue&type=style&index=0&id=04ae6f48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports